import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../../lib/theme";

export const ThemeToggle = () => {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      className="inline-flex items-center justify-center h-9 w-9 rounded-md border border-border hover:border-[hsl(var(--gold))] transition-colors"
      aria-label="Toggle theme"
      data-testid="theme-toggle-button"
    >
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};
